
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-sellers",
      function () {
        return require("private-next-pages/my-sellers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-sellers"])
      });
    }
  